module.exports = __webpack_public_path__ + "img/9788959522866.6e82abf0.jpg";